import { AxisLeft as VisxAxisLeft } from '@visx/axis';
import { tickLabelProps } from './styles';
import { Text } from '@visx/text';
import { useTranslation } from 'react-i18next';
import { ScaleLinear } from 'd3-scale';
import { MARGIN } from '@/domain/dienstplan/shared/utils/constants';

export function AxisLeft({
  maxMitarbeiterAnzahl,
  yScaleAxis,
}: {
  maxMitarbeiterAnzahl: number;
  yScaleAxis: ScaleLinear<number, number, never>;
}) {
  const { t } = useTranslation();

  const leftTickValues = Array.from(
    { length: maxMitarbeiterAnzahl },
    (_, i) => i,
  );

  return (
    <>
      <VisxAxisLeft
        top={MARGIN.top}
        tickValues={leftTickValues}
        left={MARGIN.left}
        scale={yScaleAxis}
        hideTicks
        tickLabelProps={tickLabelProps}
        stroke="#E5E5EA"
      />
      <Text
        x={17}
        y={MARGIN.top - 30}
        textAnchor="start"
        fontSize={15}
        fontWeight={600}
        fill="#000">
        {t(
          'domain.dienstplan.mindestbelegung.visualEditor.labels.anzahlMitarbeitende',
        )}
      </Text>
    </>
  );
}
